import Breadcrumb from "@/components/Breadcrumb/Breadcrumb"
import CertificatesList from "@/features/pages/Certificates/CertificatesList"

export default function Certificates() {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="fw-bolder mb-0">
          <Breadcrumb />
        </h5>
      </div>

      <CertificatesList />
    </div>
  )
}
